import { Link } from "react-router-dom";
import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";

const SERVICES = [
  {
    slug: "tree-removal",
    icon: "ri-axe-line",
    title: "Tree Removal",
    desc: "Complete removal of any tree, any size. Dead, diseased, storm-damaged, or hazardous trees safely taken down and hauled away.",
    features: ["Any size tree", "Emergency service available", "Full debris cleanup", "Crane service available"],
    price: "From $350",
    img: "https://public.readdy.ai/ai/img_res/ffcba71ffa00b080c860c5cb2fd379ef.jpg",
  },
  {
    slug: "tree-trimming",
    icon: "ri-scissors-cut-line",
    title: "Tree Trimming & Pruning",
    desc: "Professional pruning to improve tree health, shape canopy, remove dead branches, and reduce storm risk.",
    features: ["Crown thinning & cleaning", "Deadwood removal", "Clearance pruning", "Health assessment"],
    price: "From $175",
    img: "https://readdy.ai/api/search-image?query=certified%20arborist%20trimming%20large%20tree%20canopy%20with%20pole%20pruner%20bucket%20truck%20residential%20yard%20sunny%20day%20northern%20virginia%20professional%20tree%20care&width=600&height=400&seq=srv002&orientation=landscape",
  },
  {
    slug: "stump-grinding",
    icon: "ri-hammer-line",
    title: "Stump Grinding",
    desc: "Complete stump removal using commercial-grade grinders. Eliminate tripping hazards and reclaim your yard.",
    features: ["Ground to 12+ inches below grade", "Multiple stumps discount", "All sizes", "Wood chips included"],
    price: "From $150",
    img: "https://readdy.ai/api/search-image?query=professional%20stump%20grinder%20machine%20operator%20removing%20large%20tree%20stump%20residential%20lawn%20wood%20chips%20dirt%20flying%20outdoor%20stump%20grinding%20service&width=600&height=400&seq=srv003&orientation=landscape",
  },
];

export default function ServicesPage() {
  return (
    <>
      <Header />
      <main>
        {/* Hero */}
        <section className="py-20 bg-[#1a3a2e] relative">
          <div className="absolute inset-0 opacity-15">
            <img
              src="https://readdy.ai/api/search-image?query=professional%20tree%20service%20company%20crew%20large%20trucks%20equipment%20bucket%20truck%20chipper%20lined%20up%20northern%20virginia%20road%20sunrise%20dramatic%20lighting&width=1440&height=400&seq=srvhero&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative max-w-4xl mx-auto px-4 text-center">
            <span className="text-[#e8632a] font-bold text-sm uppercase tracking-widest block mb-3">What We Do</span>
            <h1 className="text-5xl lg:text-6xl font-black text-white mb-4">Our Tree Services</h1>
            <p className="text-white/70 text-xl">
              Professional tree care for Northern Virginia homeowners. Every job, every time.
            </p>
          </div>
        </section>

        {/* Services */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 lg:px-8 space-y-16">
            {SERVICES.map((svc, i) => (
              <div key={svc.slug} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${i % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
                <div className={`${i % 2 === 1 ? "lg:order-2" : ""}`}>
                  <div className="rounded-2xl overflow-hidden h-72">
                    <img src={svc.img} alt={svc.title} className="w-full h-full object-cover object-top" />
                  </div>
                </div>
                <div className={`${i % 2 === 1 ? "lg:order-1" : ""}`}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#e8632a]/10 rounded-xl">
                      <i className={`${svc.icon} text-[#e8632a] text-2xl`}></i>
                    </div>
                    <span className="text-[#e8632a] font-bold text-sm uppercase tracking-widest">{svc.price}</span>
                  </div>
                  <h2 className="text-3xl font-black text-[#1e1e1e] mb-4">{svc.title}</h2>
                  <p className="text-gray-600 leading-relaxed mb-6">{svc.desc}</p>
                  <ul className="space-y-2 mb-8">
                    {svc.features.map((f) => (
                      <li key={f} className="flex items-center gap-2 text-sm text-gray-700">
                        <i className="ri-check-line text-[#1a3a2e] font-bold"></i>
                        {f}
                      </li>
                    ))}
                  </ul>
                  <div className="flex gap-3">
                    <Link to={`/services/${svc.slug}`} className="px-6 py-3 bg-[#e8632a] text-white font-bold rounded-lg uppercase tracking-wide hover:bg-[#d0541e] transition-all cursor-pointer whitespace-nowrap">
                      Learn More
                    </Link>
                    <Link to="/contact" className="px-6 py-3 border-2 border-[#1a3a2e] text-[#1a3a2e] font-bold rounded-lg uppercase tracking-wide hover:bg-[#1a3a2e] hover:text-white transition-all cursor-pointer whitespace-nowrap">
                      Get Quote
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-[#e8632a] text-center">
          <div className="max-w-3xl mx-auto px-4">
            <h2 className="text-4xl font-black text-white mb-4">Ready to Schedule Service?</h2>
            <p className="text-white/80 mb-8">Call us or request a free estimate online. We respond fast.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" className="px-8 py-4 bg-white text-[#e8632a] font-black rounded-lg uppercase tracking-wide hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap">
                Free Estimate
              </Link>
              <a href="tel:+15407764488" className="px-8 py-4 border-2 border-white text-white font-black rounded-lg uppercase tracking-wide hover:bg-white hover:text-[#e8632a] transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2">
                <i className="ri-phone-fill"></i>(540) 776-4488
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
